module.exports = __webpack_public_path__ + "img/MF.746d8f9f.png";